// Copyright ©️ 2026 eVolve MEP, LLC

import { Navigate } from 'react-router';

import { moduleRoute } from 'app/Layout/NavBar/globalNavigationMenu';
import { useCanAccessRoute } from 'app/Layout/NavBar/NavBarContent/useCanAccessRoute';
import { useRouteSearchParam } from 'app/useRouteSearchParam';
import { useEvolveLocation } from 'components/Mantine/Navigation/useEvolveLocation';
import { isNil } from 'helpers/isNotNil';
import { useLocalStorage } from 'hooks/useLocalStorage';

/** Sends `/fabrication` links to the last Fabrication view opened, keeping the query string. */
export const FabricationRedirect = () => {
  const { search } = useEvolveLocation();
  const [workOrderId] = useRouteSearchParam('/fabrication/work-orders', 'workOrderId');
  const [lastView] = useLocalStorage('FABRICATION_VIEW', 'work-orders');
  const canAccessRoute = useCanAccessRoute();
  const view = isNil(workOrderId) && canAccessRoute(`/fabrication/${lastView}`) ? lastView : 'work-orders';
  return <Navigate replace to={{ pathname: `/${moduleRoute}/fabrication/${view}`, search }} />;
};
